import { StatusCode, type RouteResult } from "@mateothegreat/svelte5-router";

import NotFound from "$routes/not-found.svelte";

export const myDefaultRouterConfig = {
  statuses: {
    [StatusCode.NotFound]: (result: RouteResult) => {
      console.log(result);
      return {
        component: NotFound,
        props: {
          timestamp: new Date().toISOString()
        }
      };
    }
  }
};
